import Container from './container'

export default function MetodoSolveProblems() {
  return (
    <section className="text-white bg-[#040116]">
      <Container className="flex flex-col lg:flex-row lg:items-center justify-between gap-28 py-24">
        <img
          src="../assets/metodo-imagem.png"
          alt=""
          className="block aspect-square lg:aspect-auto"
        />
        <div className="space-y-5 max-w-[609px]">
          <h2 className="inline-block font-normal text-5xl">
            Método <br />
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              Solve Problems
            </span>
          </h2>
          <p className="md:text-2xl">
            <strong>
              Todo grande desafio esconde uma oportunidade de inovação.
            </strong>{' '}
            Nós aplicamos o método Solve Problems para transformar problemas
            complexos em soluções inteligentes, que geram valor real e
            impulsionam a eficiência do seu negócio.
          </p>
        </div>
      </Container>
    </section>
  )
}
